import Form from '../../common/form';
import Joi from 'joi';

import { func } from 'prop-types';

class ETSummaryItem extends Form {
	state = {
		data: {
			inspectedItem: '',
			observation: '',
			remark: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		inspectedItem: Joi.string().min(3).required().label('Inspected Item'),
		observation: Joi.string().required().label('Observation / Result'),
		remark: Joi.string().min(3).required().label('Remarks'),
	};

	static propTypes = {
		onAdd: func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onAdd(this.state.data);

		this.setState({
			data: {
				inspectedItem: '',
				observation: '',
				remark: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'inspectedItem',
							type: 'text',
							label: 'Inspected Item',
							placeholder: 'Enter Inspected Item',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'observation',
							label: 'Observation / Result',
							placeholder: 'Enter Observation / Result',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'remark',
							label: 'Remarks',
							placeholder: 'Enter Remarks',
						})}
					</div>

					<div className="col">{this.renderButton('Add Item')}</div>
				</div>
			</form>
		);
	}
}

export default ETSummaryItem;
